import React from 'react';
import {
  TIMEDEAL_WIDGET_LAYOUT_TYPE_V2,
  TimedealWidgetDetailV2,
  TimedealWidgetRequestPayloadV2,
  WIDGET_TYPE_V2,
} from '../../../../../types/widget';
import { getInitialPeriod } from '../../common/utils/getInitialPeriod';
import TimedealWidgetForm from './TimedealWidgetForm';

export interface TimedealWidgetFormWrapperProps {
  isEdit: boolean;
  initialValue?: TimedealWidgetDetailV2;
  onChangeType: (type: WIDGET_TYPE_V2) => void;
  onFinish: (value: TimedealWidgetRequestPayloadV2) => void;
}

const TimedealWidgetFormWrapper = (props: TimedealWidgetFormWrapperProps): JSX.Element => {
  const { initialValue, isEdit, onFinish, onChangeType } = props;

  const { exposurePeriod, ...restInitialValue } = initialValue || {};

  const formInitialValue = {
    type: WIDGET_TYPE_V2.TIMEDEAL,
    layoutType: TIMEDEAL_WIDGET_LAYOUT_TYPE_V2.SWIPE_1XN,
    exposurePeriod: getInitialPeriod(exposurePeriod),
    isUseCoupon: false,
    ...restInitialValue,
  };

  return (
    <TimedealWidgetForm
      isEdit={isEdit}
      initialValue={formInitialValue}
      onChangeType={onChangeType}
      onFinish={onFinish}
    />
  );
};

export default TimedealWidgetFormWrapper;
